import React, { useState, useMemo, useCallback } from 'react';

import Navigation from '../components/Navigation';

type TabProps = {
  titleList: string[];
  pageList: React.ReactNode[];
};

/**
 * @description Tab Naviagtion을 사용하여 Content를 보여주는 Layout 컴포넌트
 * @property {string[]} titleList 유저의 pubkey로 vp를 encrypted한 값
 * @property {React.ReactNode[]} pageList 유저의 pubkey로 vp를 encrypted한 값
 */
function Tab({ titleList, pageList }: TabProps) {
  // 현재 레이아웃 인덱스
  const [index, setIndex] = useState(0);
  // 현재 레이아웃 인덱스에 해당하는 Content
  const view = useMemo(() => pageList[index], [index, pageList]);
  // 레이아웃 인덱스를 변경하는 콜백 함수
  const navOnclick = useCallback((num: number) => setIndex(num), []);

  return (
    <>
      <div className="nav-container container">
        <div className="wrapper">
          <Navigation
            titleList={titleList}
            select={index}
            navOnclick={navOnclick}
          />
        </div>
      </div>
      {view}
    </>
  );
}

export default Tab;
